import React from "react";
import styled from "styled-components";
import { colorFunctionalGray50, colorMiscGray90, fontSizeS, spacingM, spacingXl } from "@rhumbix/rmbx_design_system_design_tokens";
/**
 * @param {string} value The value of the text input
 * @param {function} onChange The change handler for the text input
 * @returns
 */
export const TextInput = ({ value, onChange, ...props }) => {
    return React.createElement(StyledInput, { type: "text", value: value, onChange: onChange, ...props });
};
const StyledInput = styled.input `
    border: 1px solid ${colorFunctionalGray50};
    border-radius: 3px;
    color: ${colorMiscGray90}
    font-size: ${fontSizeS};
    height: ${spacingXl};
    padding: ${spacingM};
    width: 100%;

    &:disabled {
        color:${colorFunctionalGray50}
    }
`;
export default TextInput;
